/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unstable-nested-components */
import React, { FC, useState } from 'react';
import { styled } from 'linaria/lib/react';
import Image from 'next/image';
import Link from 'next/link';
import { Flex, Text, theme, useBreakpoint } from '@mtsbank/ui-kit';
import { News } from '@root/components/CyberNews/News';
import { newsClickGtm } from '@root/utils/gtm/cyber/events';
import { Spacer } from '../Uikit/Spacer';
import { Carousel } from '../Uikit/Carousel';
export const CyberNews: FC = () => {
  const [, setSlide] = useState(0);
  const navHandler = (id: number) => setSlide(id);
  const {
    isMobile,
    isTablet
  } = useBreakpoint();
  const blocks = Object.values(News);
  const mobileBlocks = 2;
  const tabletBlocks = 2;
  const desktopBlocks = 3;
  const makeSlides = (length: number) => Array.from({
    length: Math.ceil(blocks.length / length)
  }, (_, i) => i + 1);
  const routPath = (id: string) => {
    switch (id) {
      case 'promo-inarius':
        return '/promo-inarius';
      case 'mts-cashback-lite-mir':
        return '/mts-cashback-lite-mir';
      case 'promo-inarius-itogy':
        return '/promo-inarius-itogy';
      case 'novogodniy-rozygrysh-prizov':
        return '/novogodniy-rozygrysh-prizov';
      case 'novogodniy-rozygrysh-prizov-itogi':
        return '/novogodniy-rozygrysh-prizov-itogi';
      case 'rozygrysh-prizov':
        return '/rozygrysh-prizov';
      case 'rozygrysh-prizov-itogi':
        return '/rozygrysh-prizov-itogi';
      default:
        return `/news/${id}`;
    }
  };
  const renderSlideFn = (blocksSize: number, subtractIndex = false) => (part: number, index: number) => <SlideWrapper key={part}>
          {blocks.slice((part - 1) * blocksSize - (subtractIndex ? index : 0), part * blocksSize - (subtractIndex ? index : 0)).map(({
      id,
      title,
      describe,
      imageSlide,
      date
    }) => <Link passHref href={routPath(id)} key={id}>
                <Slide onClick={() => newsClickGtm(title)}>
                  <Flex fillHeight direction="column">
                    <Image className="image" src={imageSlide} alt="slide" width={isMobile ? 295 : 295} height={170} />
                    <DescWrapper>
                      <div>
                        <WordBreakHeading>{title}</WordBreakHeading>
                        <Spacer space={8} />
                        <TextDescWrapper>{describe}</TextDescWrapper>
                      </div>
                      <Spacer space={theme.spacings.xs} />
                      <Flex justify="space-between" alignItems="center">
                        <Text color="#888BAA" size="md">
                          {date}
                        </Text>
                      </Flex>
                    </DescWrapper>
                  </Flex>
                </Slide>
              </Link>)}
        </SlideWrapper>;
  const slides = isMobile ? makeSlides(1).map(renderSlideFn(mobileBlocks, true)) : isTablet ? makeSlides(2).map(renderSlideFn(tabletBlocks, true)) : makeSlides(desktopBlocks).map(renderSlideFn(desktopBlocks));
  if (isMobile || isTablet) {
    return <>
        <WrapperText>Новости</WrapperText>
        <Spacer spacemob={24} />
        <CarouselWrapperMobile>
          {blocks?.map(({
          id,
          title,
          describe,
          imageSlide,
          date
        }) => <Link passHref href={routPath(id)} key={id}>
              <Slide onClick={() => newsClickGtm(title)}>
                <Flex fillHeight direction="column">
                  <Image className="image" src={imageSlide} alt="slide" width={320} height={170} />
                  <DescWrapper>
                    <div>
                      <WordBreakHeading>{title}</WordBreakHeading>
                      <Spacer space={8} />
                      <TextDescWrapper>{describe}</TextDescWrapper>
                    </div>
                    <Spacer space={theme.spacings.xs} />
                    <Flex justify="space-between" alignItems="center">
                      <Text color="#888BAA" size="md">
                        {date}
                      </Text>
                    </Flex>
                  </DescWrapper>
                </Flex>
              </Slide>
            </Link>)}
        </CarouselWrapperMobile>
      </>;
  }
  return <CarouselWrapper>
      <Carousel autoplay={false} controlsPosition="top" nextHandler={navHandler} prevHandler={navHandler} heading="Новости">
        {[...slides]}
      </Carousel>
    </CarouselWrapper>;
};
const CarouselWrapper = /*#__PURE__*/styled("div")({
  name: "CarouselWrapper",
  class: "c158joop"
});
const WordBreakHeading = /*#__PURE__*/styled("h4")({
  name: "WordBreakHeading",
  class: "wccr0sh"
});
const SlideWrapper = /*#__PURE__*/styled("div")({
  name: "SlideWrapper",
  class: "stbspr8"
});
const Slide = /*#__PURE__*/styled("a")({
  name: "Slide",
  class: "s19kxq7e"
});
const DescWrapper = /*#__PURE__*/styled("div")({
  name: "DescWrapper",
  class: "dys7pp9"
});
const TextDescWrapper = /*#__PURE__*/styled("div")({
  name: "TextDescWrapper",
  class: "tlqx8cn"
});
const CarouselWrapperMobile = /*#__PURE__*/styled("div")({
  name: "CarouselWrapperMobile",
  class: "cl2f3ou"
});
const WrapperText = /*#__PURE__*/styled("div")({
  name: "WrapperText",
  class: "wg442xo"
});

require("./CyberNews.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./CyberNews.tsx");